import ProhibitedItem from '../../components/layout/ITHeadquarters/prohibitedItem';

const ProhibitedItemPage = () => {
    return <ProhibitedItem />;
};
export default ProhibitedItemPage;
